import React, { useRef, useState } from "react";
import { FileSpreadsheet, UploadCloud } from "lucide-react";

const OK_EXT = /\.(xlsm|xlsx)$/i;

export const EaImportDropzone = ({ onFiles, disabled }) => {
  const [over, setOver] = useState(false);
  const input = useRef(null);
  const pick = (list) => {
    const files = Array.from(list || []).filter((f) => OK_EXT.test(f.name));
    if (files.length) onFiles(files);
  };
  return (
    <div
      onDragOver={(e) => { e.preventDefault(); setOver(true); }}
      onDragLeave={() => setOver(false)}
      onDrop={(e) => { e.preventDefault(); setOver(false); if (!disabled) pick(e.dataTransfer.files); }}
      onClick={() => !disabled && input.current?.click()}
      className={`rounded-2xl border-2 border-dashed p-8 text-center cursor-pointer transition-colors ${over ? "border-purple-500 bg-purple-50" : "border-slate-300 bg-slate-50/60 hover:border-purple-400 hover:bg-purple-50/40"} ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
      data-testid="ea-import-dropzone"
    >
      <UploadCloud size={32} className="mx-auto text-purple-500" />
      <div className="mt-2 font-display font-semibold text-slate-800">Trascina qui i file Excel di controllo fatture</div>
      <div className="text-xs text-slate-500 mt-1 inline-flex items-center gap-1">
        <FileSpreadsheet size={12} /> .xlsm o .xlsx · anche più file insieme · oppure clicca per selezionarli
      </div>
      <input
        ref={input}
        type="file"
        multiple
        accept=".xlsm,.xlsx"
        className="hidden"
        onChange={(e) => { pick(e.target.files); e.target.value = ""; }}
        data-testid="ea-import-file-input"
      />
    </div>
  );
};

export default EaImportDropzone;
